module.exports = __webpack_public_path__ + "static/media/overview-total.50b36b5e.svg";